import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';

interface PopupData {
  block: boolean;
  clientName: string;
  confirmAction?: (reason: string) => void;
}

interface Props {
  popupData: PopupData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleBlockClientModal',
  props: {
    popupData: null
  },
  setup(__props: any) {

const props = __props as {
  popupData: PopupData;
};



const reason = ref<string>('');

function onCancel() {
  EventBus.$emit(EventBusEvents.closePopup);
}

function onConfirm() {
  if (props.popupData.confirmAction) {
    props.popupData.confirmAction(reason.value);
  }
}

return { __sfc: true,props, reason, onCancel, onConfirm }
}

})